module.exports = __webpack_public_path__ + "static/media/8.b4494d7b.jpg";